<template>
  <div style="margin-top: 30px; padding:11px;">
    <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
      SGK Tavanı Ekle
    </button>
    <br>
    <div class="table-responsive">
      <table class="table align-middle">
        <thead>
        <tr>
          <td><b>SGK Tavanı</b></td>
          <td><b>İşlemler</b></td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="val in SGKCeilingnData" :key="val.id">
          <td><b>{{ formatCurrency(val.sgkCeilingPrice) }}</b></td> <!-- TL formatı -->
          <td>
            <button type="button" class="btn btn-danger"
                    data-bs-toggle="modal"
                    data-bs-target="#companyDeleteModal"
                    @click="setDeleteId(val.id)">Sil</button>
            &nbsp;
            <button type="button" class="btn btn-secondary"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    @click="editSgkCeiling(val)">Düzenle</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Silme Modalı -->
    <div class="modal fade" id="companyDeleteModal" tabindex="-1" aria-labelledby="companyDeleteModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="companyDeleteModalLabel">Silme Onayı</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>Bu öğeyi silmek istediğinizden emin misiniz?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">İptal</button>
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="SeniorityBurdenDelete(deleteId)">
              Evet, Sil
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Ekleme ve Düzenleme Modalı -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content" style="min-height: 500px; width: 750px;">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ isEditing ? 'SGK Tavanı Düzenle' : 'SGK Tavanı Ekle' }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="mb-3">
              <label for="exampleFormContFirmaInput1" class="form-label">SGK Tavanı</label>
              <input type="number" class="form-control" v-model="itemsSgkCeiling.sgkCeilingPrice" placeholder="SGK Tavanı">
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Vazgeç</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="isEditing ? updateSgkCeiling() : SeniorityCeilingSave()">
              {{ isEditing ? 'Güncelle' : 'Kaydet' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from "@/axios";

export default {
  name: "SGKCeiling",
  data() {
    return {
      SGKCeilingnData: [],
      deleteId: null,
      isEditing: false,  // Düzenleme kontrolü
      itemsSgkCeiling: { sgkCeilingPrice: null, id: null },  // Güncelleme için ID ekledik
    };
  },
  created() {
    this.getSeniortyData();
  },
  methods: {
    // SGK Tavanı Kaydet
    SeniorityCeilingSave() {
      apiClient.post("/sgkCeiling", this.itemsSgkCeiling).then(() => {
        this.getSeniortyData();
        this.itemsSgkCeiling = { sgkCeilingPrice: null };
      }).catch(error => {
        console.error("Kaydetme işlemi sırasında hata oluştu:", error);
      });
    },

    // SGK Tavanı Verilerini Getir
    getSeniortyData() {
      apiClient.get("/sgkCeiling").then(res => {
        this.SGKCeilingnData = res.data;
      }).catch(error => {
        console.error("Veri çekme işlemi sırasında hata oluştu:", error);
      });
    },

    // Silme ID'sini Ayarlama
    setDeleteId(id) {
      this.deleteId = id;
    },

    // Silme İşlemi
    SeniorityBurdenDelete(id) {
      apiClient.delete(`/sgkCeiling/${id}`).then(() => {
        this.getSeniortyData();
      }).catch(error => {
        console.error("Silme işlemi sırasında hata oluştu:", error);
      });
    },

    // Para birimini formatla
    formatCurrency(value) {
      if (value !== undefined && value !== null) {
        return new Intl.NumberFormat('tr-TR', {
          style: 'currency',
          currency: 'TRY',
          minimumFractionDigits: 2
        }).format(value);
      }
      return '₺0,00';
    },

    // Düzenleme için modalı açma
    editSgkCeiling(sgkCeiling) {
      this.itemsSgkCeiling = {
        sgkCeilingPrice: sgkCeiling.sgkCeilingPrice,
        id: sgkCeiling.id
      };
      this.isEditing = true;
    },

    // SGK Tavanı Güncelleme
    updateSgkCeiling() {
      apiClient.put(`/sgkCeiling/${this.itemsSgkCeiling.id}`, this.itemsSgkCeiling).then(() => {
        this.getSeniortyData();
        this.isEditing = false;
        this.itemsSgkCeiling = { sgkCeilingPrice: null };
      }).catch(error => {
        console.error("Güncelleme işlemi sırasında hata oluştu:", error);
      });
    },
  },
};
</script>

<style scoped>
</style>
